import config from "@/modules/config";
import { valueNames } from "@/modules/Constants";
import * as orientationManager from "@/modules/orientationManager";
import {
  orientationType,
  isImmersiveLandscapeSize,
} from "@/modules/orientationManager";
import { isMcpLandscapeLayout } from "@/modules/mcpSurface";

export default class ApplicationData {
  declare _showFavorites: boolean;
  declare _showArticleActionSheet: boolean;
  declare _showShopWindow: boolean;
  declare _pauseVideo: boolean;
  declare _videoPosition: number;
  // A string-keyed map (valueNames keys).
  declare _values: Record<string, unknown>;
  declare _hasMobileExit: boolean | undefined;
  declare _hasDesktopExit: boolean | undefined;
  declare _hasFavoriteDetailsDescription: boolean | undefined;

  constructor(applicationData?: Record<string, unknown>) {
    Object.assign(this, applicationData);
    this._showFavorites = false;
    this._showArticleActionSheet = false;
    // Immersive (phone-scale) landscape AND the MCP landscape layout
    // open their shop window as an on-demand overlay sheet, so it starts CLOSED
    // (no tab chosen until the user taps one). Portrait and desktop landscape
    // (the split) keep the configured default (the panel is visible up front).
    const isImmersiveLandscape =
      orientationManager.getOrientation() === orientationType.LANDSCAPE &&
      isImmersiveLandscapeSize();
    this._showShopWindow =
      isImmersiveLandscape || isMcpLandscapeLayout()
        ? false
        : config.showShopWindow();
    this._pauseVideo = false;
    this._videoPosition = -1; // -1 to ignore,
    this._values = {};
    this.setValue(valueNames.ORIENTATION, orientationManager.getOrientation());
  }

  /*
   * Returns a combination of showShopWindow and
   * showFavorites. If we show favorites then we never show the
   * shop window, otherwise we return the results of setShowSopWindow(value)
   */

  orientation() {
    return this.getValue(valueNames.ORIENTATION);
  }

  getValue(key: string, deflt?: unknown): unknown {
    return this._values[key] || deflt;
  }

  setValue(key: string, value: unknown) {
    this._values[key] = value;
  }

  isPortrait() {
    return this.orientation() === orientationType.PORTRAIT;
  }

  isLandscape() {
    return this.orientation() === orientationType.LANDSCAPE;
  }

  pauseVideo() {
    return this._pauseVideo;
  }

  setPauseVideo(value: boolean) {
    this._pauseVideo = value;
  }

  videoPosition() {
    return this._videoPosition;
  }

  setVideoPosition(value: number) {
    this._videoPosition = value;
  }

  showShopWindow() {
    return this._showShopWindow;
  }

  setShowShopWindow(value: boolean) {
    this._showShopWindow = value;
  }

  showFavorites() {
    return this._showFavorites;
  }

  setShowFavorites(value: boolean) {
    this._showFavorites = value;
  }

  showArticleActionSheet() {
    return this._showArticleActionSheet;
  }

  setShowArticleActionSheet(value: boolean) {
    this._showArticleActionSheet = value;
  }

  hasMobileExit() {
    return this._hasMobileExit;
  }

  setHasMobileExit(value: boolean) {
    this._hasMobileExit = value;
  }

  hasDesktopExit() {
    return this._hasDesktopExit;
  }

  setHasDesktopExit(value: boolean) {
    this._hasDesktopExit = value;
  }

  hasFavoriteDetailsDescription() {
    return this._hasFavoriteDetailsDescription;
  }

  setHasFavoriteDetailsDescription(value: boolean) {
    this._hasFavoriteDetailsDescription = value;
  }
}
